import { render, staticRenderFns } from "./ColourPicker.vue?vue&type=template&id=54c9de05&scoped=true&"
import script from "./ColourPicker.vue?vue&type=script&lang=ts&"
export * from "./ColourPicker.vue?vue&type=script&lang=ts&"
import style0 from "./ColourPicker.vue?vue&type=style&index=0&id=54c9de05&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c9de05",
  null
  
)

export default component.exports